import React from 'react';
import BootstrapDropdown from 'react-bootstrap/Dropdown';
import PropTypes from 'prop-types';

function Dropdown({onSelected, opts, selected, direction}) {
        const label = opts.find((item)=>item.value == selected)?.label;
        return (
            <BootstrapDropdown drop={direction}>
                <BootstrapDropdown.Toggle as={"button"} className={'btn btn-link btn-sm px-0'}>
                    <span>{label}</span>
                </BootstrapDropdown.Toggle>
                <BootstrapDropdown.Menu>
                    {
                        opts.map((item) => <BootstrapDropdown.Item key={String(item.value)}
                                                         onClick={()=>onSelected(item.value)}>{item.label}</BootstrapDropdown.Item>)
                    }
                </BootstrapDropdown.Menu>
            </BootstrapDropdown>
        )
}

Dropdown.propTypes = {
    opts: PropTypes.array.isRequired,
    selected: PropTypes.any.isRequired,
    onSelected: PropTypes.func.isRequired,
}

export default Dropdown;
